// extracted by mini-css-extract-plugin
export default {"phoneAndText":"OurMission_phoneAndText__mxmpy","phone_pic":"OurMission_phone_pic__GOm+L","texts":"OurMission_texts__IF03Y"};